var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:[ 'sf-pill', ("sf-pill--" + _vm.pillColor) ],attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.$t(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }